<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper" >
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品编号')" prop="id">
                  <a-input v-model="queryParam.id" :maxLength="20" :placeholder="$t('请输入')+$t('商品编号')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="queryParam.goodsName" :maxLength="16" :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品分类')" prop="categoryId">
                  <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                                 :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="$t('请选择')+$t('商品分类')"
                                 :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                 tree-default-expand-all allow-clear>
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商品类型" prop="goodsTypeList">
                  <a-select mode="multiple" :disabled="goodsTypeList!==undefined" :placeholder="$t('请选择')+'商品类型'" style="width: 100%" v-model="queryParam.goodsTypeList" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsTypeEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品状态')" prop="status">
                  <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                    <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="  6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :customRow="loadCustomRow"
          :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio',  onChange: onSelectChange}"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.GoodsStatusEnum" :value="record.status"/>
         </span>
          <span slot="goodsTypeList" slot-scope="text, record">
           <custom-dict-tag :options="customDict.goodsTypeListEnum" :value="record.goodsTypeList"/>
         </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
    </a-card>
  </a-modal>
</template>

<script>
import {pageSelectGoods,listSelectGoods} from '@/api/goods/goods'
import {platformCategoryList} from '@/api/goods/category'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {tableMixin} from '@/store/table-mixin'


export default {
  name: 'CheckboxGoodsSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      goodsTypeList:undefined,
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      limitNum: undefined,
      selectedRowKeys: [],
      selectedRows: [],
      categoryList: [],
      cateOptions: [],
      brandList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      idText:null,
      // 查询参数
      queryParam: {
        goodsCode: null,
        goodsName: null,
        excludeId: undefined,
        goodsTypeList:[],
        merchantIdList: [],
        categoryId: null,
        orderByGoodsIdList:undefined,
        shopId: null,
        shopCategoryId: null,
        brandId: null,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        starName: null,
        prodArea: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          width: 200,
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 200,
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '商品类型',
          dataIndex: 'goodsTypeList',
          scopedSlots: {customRender: 'goodsTypeList'},
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
        },
      ]
    };
  },
  filters: {},
  created() {
    this.getCategoryList();
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    selectGoodsAll() {
      //查询该条件下所有的商品,
      listSelectGoods(this.queryParam).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
        this.onOk()
      })

      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param id
     * @param excludeId
     * @param merchantIdList 商家id列表,
     * @param goodsTypeList
     */
    openGoods(id, excludeId, merchantIdList, goodsTypeList) {
      if (merchantIdList) {
        this.queryParam.merchantIdList = merchantIdList;
      }
      if (id) {
        console.log('带过来的key', id)
        this.selectedRowKeys = [id]
        this.queryParam.orderByGoodsIdList = [id];
      }
      if (excludeId) {
        this.queryParam.excludeId = excludeId
      }
      if (goodsTypeList) {
        this.goodsTypeList = goodsTypeList
        this.queryParam.goodsTypeList = goodsTypeList
      }
      this.getList();
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('goodsSelect', this.selectedRows)
      this.resetQueryForm()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.resetQueryForm()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSelectGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getCategoryList() {
      //查询平台分类
      platformCategoryList({"merchantId":0}).then(response => {
        this.categoryList = response.data
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },
    resetQueryForm() {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        goodsCode: null,
        goodsName: null,
        excludeId: undefined,
        goodsTypeList:[],
        merchantIdList: [],
        categoryId: null,
        orderByGoodsIdList:undefined,
        shopId: null,
        shopCategoryId: null,
        starId: this.queryParam.starId,
        brandId: null,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        starName: null,
        prodArea: null,
        pageNum: 1,
        pageSize: 10
      }
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.limitNum) {
          if (this.selectedRows.length >= this.limitNum) {
            console.log('到达了限制数量,',this.limitNum)
            return false
          }
        }
        this.selectedRows.push(record)
      } else {
        this.selectedRows = this.selectedRows.filter(e => e.id !== record.id);
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRows =this.selectedRows.concat(changeRows)
      } else {
        let selectIds = changeRows.map(e => e.id);
        this.selectedRows = this.selectedRows.filter(e => !selectIds.includes(e.id));
      }
      this.ids = this.selectedRows.map(item => item.id)
      this.selectedRowKeys = this.ids;
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            // 记录为disabled则直接返回，默认为不可选
            if (this.selectedRowKeys.find(e=>e.id===record.id)) {
              return;
            }
            let selectedRowKeys  = [record.id]
            let selectedRows =[record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          },
          dblclick: () => {
            this.onOk()
          },
        }
      }
    },
  }
}
</script>
